import {FiTrash2} from 'react-icons/fi';
import {BsCheckCircleFill} from 'react-icons/bs';
import {Modal, Progress, Radio} from 'antd';
import {useDocumentContext} from '../../SimpleDocument';
import {deleteDocumentById, uploadFile} from '../../api/Document.api';
import styled from 'styled-components';
import {getFileExtension, isOpenFile, sleep} from "../../utils/ExtensionUtils";
import {FileFields} from "../../utils/FieldUtils";
import {documentCategory} from "../../utils/Common";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import PreviewV2 from "../../../../../custom/preview";

const Index = ({referenceCodeItem}) => {

    const {newDataSource, listProgressFiles, radioSelect} = useDocumentContext();

    const renderUploadFileItem = (key, data) => {

        if (!!data.error) {

            return <ErrorUploadFileItem key={key} data={data} referenceCodeItem={referenceCodeItem}/>;
        } else {

            if (data.percent === 100) {

                return <SuccessUploadFileItem key={key} data={data}/>;
            } else {

                return <ProgressUploadFileItem key={key} data={data}/>;
            }
        }
    };

    return (
        <div className={'list-upload-file overflow-y-auto'}>

            {Object.keys(listProgressFiles)?.map(key => {

                return renderUploadFileItem(key, listProgressFiles[key]);
            })}

            {radioSelect ? (
                <Radio.Group className={'w-full'} style={{fontSize: "unset"}} {...radioSelect}>
                    {Object.keys(newDataSource)?.map(key => {

                        return <UploadFileItem key={key} data={newDataSource[key]} radioSelect={radioSelect} referenceCodeItem={referenceCodeItem}/>;
                    })}

                </Radio.Group>
            ) : (
                Object.keys(newDataSource)?.map(key => {

                    return <UploadFileItem key={key} data={newDataSource[key]} referenceCodeItem={referenceCodeItem}/>;
                })
            )}
        </div>
    );
};

export default Index;

const UploadFileItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px
`;

const UploadFileItemTitle = styled.div`
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
`;

const UploadFileItem = (properties) => {

    const {setReloadData} = useDocumentContext();

    const {data, radioSelect,referenceCodeItem} = properties;

    const [visible, setVisible] = useState(false)

    const {t} = useTranslation()

    function onDelete() {
        Modal.confirm({
            title: t("DGDocument.heading.delete", {name: data.name, type: t("DGDocument.text." + data.type)}),
            onOk: () => {
                return deleteDocumentById(data.id).then(() => {
                    setReloadData(true);
                });
            },
            okText : t("common.btn.delete"),
            cancelText: t("common.btn.no"),
            onCancel: () => {

            }
        });
    }

    const isSelect = radioSelect?.value === data?.fileId

    return (
        <>
            <div className={'upload-file-item'} style={{
                borderColor: isSelect ? "var(--primary-color)" : null,
                borderWidth: isSelect ? 2 : null
            }}>
                <UploadFileItemWrapper style={{marginBottom: 4, cursor: "pointer"}}>
                    <div className={"flex"}>
                        {radioSelect && (<Radio value={data.fileId}/>)}
                        <UploadFileItemTitle onClick={() => setVisible(true)}>
                            <span style={{
                                color: isSelect ? "var(--primary-color)" : null
                            }}>{data?.name}</span> {isSelect &&
                            <span className={"text-xs italic text-[gray]"}>({t("common.default")})</span>}
                        </UploadFileItemTitle>
                    </div>

                    {((referenceCodeItem && !data?.pkCode?.includes("_")) || !referenceCodeItem) && <div className={'upload-file-item__icon'} onClick={onDelete}>
                        <FiTrash2/>
                    </div> }
                </UploadFileItemWrapper>
            </div>

            {isOpenFile(getFileExtension(data.name)) && (
                <PreviewV2
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    fileId={data.fileId}
                />
            )}
        </>
    );
};

const SuccessUploadFileItem = (props) => {

    const {data} = props;

    const primaryTextColor = {
        color: "var(--primary-color)"
    };

    const primaryBorderColor = {
        borderColor: "var(--primary-color)"
    };

    return (
        <div className={'upload-file-item'} style={primaryBorderColor}>
            <UploadFileItemWrapper style={{marginBottom: 4}}>
                <UploadFileItemTitle>
                    {data.name}

                </UploadFileItemTitle>

                <div className={'upload-file-item__icon'}>
                    <BsCheckCircleFill style={primaryTextColor}/>
                </div>
            </UploadFileItemWrapper>

            <UploadFileItemWrapper>
                <div style={{flex: 1, marginRight: 24}}>
                    <Progress showInfo={false} percent={100} strokeColor={"var(--primary-color)"}
                              style={{marginBottom: 0}}/>
                </div>
                <div className={'upload-file-item__percent'}>
                    100%
                </div>
            </UploadFileItemWrapper>
        </div>
    );
};

export const ProgressUploadFileItem = (props) => {

    const {data} = props;

    const {
        primaryColor,
        setListProgressFiles
    } = useDocumentContext();

    const {t} = useTranslation()

    function cancelUpload() {

        Modal.confirm({
            title: t("DGDocument.heading.delete", {name: data.name, type: t("DGDocument.text." + data.type)}),
            onOk: () => {
                setListProgressFiles(state => {

                    const cloneState = {...state}

                    delete cloneState[data.uid]

                    return cloneState
                })
                !!data?.controller?.abort && data?.controller?.abort()
            },
            okText : t("common.btn.delete"),
            cancelText: t("common.btn.no")
        })
    }

    return (
        <div className={'upload-file-item'}>
            <UploadFileItemWrapper style={{marginBottom: 4}}>
                <UploadFileItemTitle>
                    {data.name}
                </UploadFileItemTitle>


                <div className={'upload-file-item__icon'} onClick={cancelUpload}>
                    <FiTrash2/>
                </div>
            </UploadFileItemWrapper>

            <UploadFileItemWrapper>
                <div style={{flex: 1, marginRight: 24}}>
                    <Progress showInfo={false} percent={data.percent} strokeColor={"var(--primary-color)"}
                              style={{marginBottom: 0}}/>
                </div>
                <div className={'upload-file-item__percent'}>
                    {data.percent}%
                </div>
            </UploadFileItemWrapper>
        </div>
    );
};

const ErrorUploadFileItem = (props) => {

    const {data,referenceCodeItem} = props;

    const {
        setListProgressFiles,
        setReloadData,
        externalReferenceCode,
        appId,
        moduleId
    } = useDocumentContext();

    const {t} = useTranslation()

    function onDelete() {

        Modal.confirm({
            title: t("DGDocument.heading.delete", {name: data.name, type: t("DGDocument.text." + data.type)}),
            onOk: () => {
                setListProgressFiles(state => {

                    const cloneState = {...state}

                    delete cloneState[data.uid]

                    return cloneState
                })
            },
            okText : t("common.btn.delete"),
            cancelText: t("common.btn.no")
        })
    }

    const mapFileItem = (item, percent) => {

        return {
            extension: item?.name?.split('.').pop(),
            ...item,
            percent: Number(percent)
        };
    };

    async function reUpload() {

        const controller = new AbortController();

        const initProgressFile = mapFileItem({
            uid: data.uid,
            name: data.name,
            file: data.file,
            controller: controller
        }, 0);

        setListProgressFiles((state) => {

            const cloneState = {...state};

            cloneState[data.uid] = initProgressFile;

            return {...cloneState};
        });

        const formData = new FormData();

        formData.append(FileFields.metadata, JSON.stringify({appId, moduleId}));
        formData.append(FileFields.pkCode, referenceCodeItem || externalReferenceCode);
        formData.append(FileFields.parentId, '0');
        formData.append(FileFields.category, documentCategory.attached);
        formData.append(FileFields.file, data.file);

        const onUploadProgress = (progressEvent) => {

            const total = progressEvent?.total || 0;
            const loaded = progressEvent?.loaded;

            let percent = (loaded / total) * 100;

            percent = percent === 100 ? 99 : parseInt(String(percent));

            setListProgressFiles((state) => {

                const cloneState = {...state};

                cloneState[data.uid] = mapFileItem(initProgressFile, percent);

                return {...cloneState};
            });
        };

        await uploadFile(formData, onUploadProgress, {signal: controller.signal}).then(r => {

            setListProgressFiles((state) => {

                const cloneState = {...state};

                cloneState[data.uid] = mapFileItem(initProgressFile, 100);

                return {...cloneState};
            });

            sleep(500).then(() => {
                setReloadData(true)
            })


        }).catch(e => {

        });
    }

    return (
        <div className={'upload-file-item--error'}>
            <UploadFileItemWrapper style={{marginBottom: 4}}>
                <UploadFileItemTitle>
                    {data.name}
                </UploadFileItemTitle>

                <div className={'upload-file-item__icon'} onClick={onDelete}>
                    <FiTrash2/>
                </div>
            </UploadFileItemWrapper>

            <UploadFileItemWrapper>
                <div style={{flex: 1, marginRight: 24}}>
                    {data.error.type === "client" ? (
                        <>
                            {data.error.message}
                        </>
                    ) : (
                        <>
                            {t("tnp.components.file.uploadError")} <span
                            style={{fontWeight: 550, cursor: "pointer"}}
                            onClick={reUpload}
                        >
                            {t("DGDocument.text.onclick")}
                            </span> {t("DGDocument.text.toTry")}
                        </>
                    )}
                </div>
                <div className={'upload-file-item__percent'}>
                </div>
            </UploadFileItemWrapper>
        </div>
    );
};